<template>
	<b-list-group-item>
			<div class="mb-3 d-flex justify-content-between">
				<span class="lead">{{spellLevel | ordinal}}</span>
				<b-input-group size="sm" class="w-50" v-if="spellLevel != 0">
					<b-input-group-prepend>
						<b-button size="sm" variant="default" @click="decrease()">-</b-button>
					</b-input-group-prepend>
					<input type="number" class="form-control text-center" v-model.number="spellSlotsUsed" />
					<input type="number" class="form-control text-center" disabled :value="spellsPerDay" />
					<b-input-group-append>
						<b-button size="sm" variant="default" @click="increase()">+</b-button>
					</b-input-group-append>
				</b-input-group>
				<small class="text-muted">DC {{spellSaveDc}}</small>
			</div>
			<ul class="list-inline mb-0">
				<li class="list-inline-item" v-for="(spell, index) in spellList" :key="'spell-list-'+index">
					<a :href="'https://thehiddentruth.info/player/spells/?page='+ spellConcat(spell.Name)" target="_outside">{{spell.Name}}</a>
				</li>
			</ul>
		</b-list-group-item>
</template>

<script>
export default {
	props: ['spellLevel','spellSaveDc','spellsKnown','spellsPerDay'],
	computed: {
		spellList: function(){
			return this.$store.getters['character/spells/list'][this.spellLevel]
		},
		spellSlotsUsed: {
			get: function() {
				return this.$store.state.Character.Current.SpellSlots[this.spellLevel]
			},
			set: function(value) {
				this.setSpellSlots(value)
			}
		},
	},
	methods: {
		setSpellSlots: function(value) {
			this.$store.commit('setCharacterProp',[
				{
					key: `Current.SpellSlots[${this.spellLevel}]`,
					val: value,
				}
			])
		},
		spellConcat: function(spell){
			var name = spell.replace(/[^a-zA-Z-]+/g, '');
			if(name.toLowerCase().substr(0,6) == 'lesser'){
				name = name.substr(6) + 'Lesser'
			}
			else if(name.toLowerCase().substr(0,7) == 'greater'){
				name = name.substr(7) + 'Greater'
			}
			return name;
		},
		increase: function() {
			if( this.spellSlotsUsed < this.spellsPerDay )
				this.setSpellSlots( this.spellSlotsUsed + 1 )
		},
		decrease: function() {
			if( this.spellSlotsUsed > 0 )
				this.setSpellSlots( this.spellSlotsUsed - 1 )
		}
	},
}
</script>

<style scoped>

</style>